"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceEstimateRequestToJSON = exports.AudienceEstimateRequestFromJSONTyped = exports.AudienceEstimateRequestFromJSON = exports.instanceOfAudienceEstimateRequest = void 0;
var runtime_1 = require("../runtime");
var AssetFormat_1 = require("./AssetFormat");
var BidStrategyRequest_1 = require("./BidStrategyRequest");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var CampaignChannel_1 = require("./CampaignChannel");
var EstimateBudget_1 = require("./EstimateBudget");
var FrequencyCap_1 = require("./FrequencyCap");
var OptimizationPrefs_1 = require("./OptimizationPrefs");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the AudienceEstimateRequest interface.
 */
function instanceOfAudienceEstimateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "adAccountId" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "assetFormat" in value;
    isInstance = isInstance && "objective" in value;
    isInstance = isInstance && "bidStrategy" in value;
    isInstance = isInstance && "bidMicroAmount" in value;
    isInstance = isInstance && "budget" in value;
    isInstance = isInstance && "targets" in value;
    return isInstance;
}
exports.instanceOfAudienceEstimateRequest = instanceOfAudienceEstimateRequest;
function AudienceEstimateRequestFromJSON(json) {
    return AudienceEstimateRequestFromJSONTyped(json, false);
}
exports.AudienceEstimateRequestFromJSON = AudienceEstimateRequestFromJSON;
function AudienceEstimateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': json['ad_account_id'],
        'startDate': (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'assetFormat': (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsFromJSON)(json['objective']),
        'bidStrategy': (0, BidStrategyRequest_1.BidStrategyRequestFromJSON)(json['bid_strategy']),
        'bidMicroAmount': json['bid_micro_amount'],
        'budget': (0, EstimateBudget_1.EstimateBudgetFromJSON)(json['budget']),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'hierarchyDraftId': !(0, runtime_1.exists)(json, 'hierarchy_draft_id') ? undefined : json['hierarchy_draft_id'],
        'adsetDraftId': !(0, runtime_1.exists)(json, 'adset_draft_id') ? undefined : json['adset_draft_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'channel': !(0, runtime_1.exists)(json, 'channel') ? undefined : (0, CampaignChannel_1.CampaignChannelFromJSON)(json['channel']),
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'submission': !(0, runtime_1.exists)(json, 'submission') ? undefined : json['submission'],
        'forecastItemId': !(0, runtime_1.exists)(json, 'forecast_item_id') ? undefined : json['forecast_item_id'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
    };
}
exports.AudienceEstimateRequestFromJSONTyped = AudienceEstimateRequestFromJSONTyped;
function AudienceEstimateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'start_date': (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsToJSON)(value.objective),
        'bid_strategy': (0, BidStrategyRequest_1.BidStrategyRequestToJSON)(value.bidStrategy),
        'bid_micro_amount': value.bidMicroAmount,
        'budget': (0, EstimateBudget_1.EstimateBudgetToJSON)(value.budget),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'hierarchy_draft_id': value.hierarchyDraftId,
        'adset_draft_id': value.adsetDraftId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'channel': (0, CampaignChannel_1.CampaignChannelToJSON)(value.channel),
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'salesforce_line_item_id': value.salesforceLineItemId,
        'submission': value.submission,
        'forecast_item_id': value.forecastItemId,
        'category': value.category,
    };
}
exports.AudienceEstimateRequestToJSON = AudienceEstimateRequestToJSON;
